import { client } from "src/services/client";

export const fetchAssignment = async (query: { [key: string]: string }) =>
    client({
        method: "get",
        url: `/assignments?${query.filters}`,
        headers: { "Content-Type": "application/json" },
    }).then((response) => response.data);
